import { FormInstance } from "antd";
import { Fragment } from "react";
import CustomInput from "../../../commons/components/CustomInput/CustomInput";
import CustomPhoneInput from "../../../commons/components/CustomPhoneInput/CustomPhoneInput";
import { UpdateAccountInformationFormFields } from "../../../commons/constants/formField";
import { filterECharacterInputNumber, integerOnlyInput } from "../../../commons/utils/functions/integerOnly";
import removeExtraSpace from "../../../commons/utils/functions/removeExtraSpace";
import styles from "../../../components/AccountInformation/AccountInformation.module.scss";

interface AcountInformationProps {
  form: FormInstance;
  phonePattern: any;
  handleTrackFieldsTouched: (fieldName: string) => void;
}

const AcountInformation: React.FC<AcountInformationProps> = ({ form, phonePattern, handleTrackFieldsTouched }) => {
  return (
    <>
      <h2 className={styles.infoTitle}>Account Information</h2>
      <div className={styles.detail}>
        <div className={styles.column}>
          {UpdateAccountInformationFormFields.slice(0, 2).map((field, idx) => {
            if (field.type === "number") {
              return (
                <CustomInput
                  className={styles.input}
                  key={idx}
                  label={field.title}
                  type={field.type}
                  onKeyDown={event => {
                    integerOnlyInput(event);
                  }}
                  onChange={e => {
                    handleTrackFieldsTouched(field.name);
                    filterECharacterInputNumber(field.name, form, e);
                  }}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  name={field.name}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                />
              );
            } else {
              return (
                <CustomInput
                  className={styles.input}
                  key={idx}
                  label={field.title}
                  type={field.type}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  name={field.name}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                  onChange={() => {
                    handleTrackFieldsTouched(field.name);
                  }}
                />
              );
            }
          })}
        </div>
        <div className={[styles.column, styles.secondColumn].join(" ")}>
          {UpdateAccountInformationFormFields.slice(2, 4).map(field => {
            if (field.name === "phone") {
              return (
                <Fragment key={field.name}>
                  <CustomPhoneInput
                    className={styles.input}
                    label={field.title}
                    formInstance={form}
                    placeholder="Phone number"
                    name={"phone"}
                    onChangeRegion={handleTrackFieldsTouched}
                    onChange={() => {
                      handleTrackFieldsTouched(field.name);
                    }}
                    rules={[
                      {
                        required: false,
                        message: "This field is required",
                      },
                      {
                        pattern: phonePattern,
                        message: "Invalid phone number",
                      },
                    ]}
                  />
                </Fragment>
              );
            }
          })}
          <CustomInput
            className={styles.input}
            label={"Applicant's name"}
            type={"string"}
            maxLength={100}
            rules={[
              {
                required: true,
                message: "This field is required",
                whitespace: true,
              },
            ]}
            placeholder={"Enter Applicant's name"}
            name={"applicantName"}
            onBlur={removeExtraSpace("applicantName", form)}
            style={{ marginBottom: "0px" }}
            onChange={() => {
              handleTrackFieldsTouched("applicantName");
            }}
          />
        </div>
      </div>
    </>
  );
};

export default AcountInformation;
